<template>
  <div>
    <card-component :title="cardTitle" :icon="cardIcon">
    <div class="columns is-multiline">

        <div class="column is-12">
          <div class="columns">
            <div class="column is-4">
            <div class="field">
              <label class="label">Franchisee Name <span class="has-text-danger">*</span></label>
              <div class="control">
                <input class="input" type="text" v-model="value.franchiseeName" :readonly="isReadonly" :disabled="isDisabled">
              </div>
            </div>
        </div>
        <div class="column is-4">
            <div class="field">
              <label class="label">Academic Year <span class="has-text-danger">*</span></label>
              <div class="control">
                <input class="input" type="text" v-model="value.getAcademicYear" :readonly="isReadonly" :disabled="isDisabled">
              </div>
            </div>
        </div>
        <div class="column is-4">
            <div class="field">
              <label class="label">Class <span class="has-text-danger">*</span></label>
              <div class="control">
                <input class="input" type="text" v-model="value.getClassName" :readonly="isReadonly" :disabled="isDisabled">
              </div>
            </div>
          </div>
        </div>
    </div>

    </div>

    </card-component>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import moment from 'moment'
export default {
  name: 'FranchiseeElement',
  props: {
    formType: {
      default: '',
      type: String
    },
    value: {
      default: () => {},
      type: Object
    },
    isWritable: {
      default: 'false',
      type: String
    }
  },
  components: {
    CardComponent
  },
  data: function () {
    return {
      studType: 'NewAdmission',
      isApplication: false,
      isReadonly: false,
      isDisabled: false,
      cardTitle: '',
      cardIcon: '',
      franchiseeName: '',
      academicYear: '',
      className: '',
      franchiseeAcademicYear: '',
      studentClass: '',
      maxToDate: moment().format('YYYY-MM-DD')
    }
  },
  mounted () {
    if (this.isWritable === 'false') {
      this.isReadonly = true
      this.isDisabled = true
    }
  },

  created () {
    if (this.isWritable === 'false') {
      this.isReadonly = true
      this.isDisabled = true
    }
    if (this.formType === 'application') {
      this.isApplication = true
    }
    if (this.formType !== 'admission') {
      this.cardTitle = 'Student Details'
      this.cardIcon = 'account mdi-18px p-r-10'
    }
  },
  methods: {

  }
}
</script>
